import { render, staticRenderFns } from "./roleitemlist.vue?vue&type=template&id=780d3cc6&"
import script from "./roleitemlist.vue?vue&type=script&lang=js&"
export * from "./roleitemlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports